import type { DeliveryInstruction } from './interfaces'

export const isCustomDeliveryInstruction = (value: DeliveryInstruction): boolean =>
  ['Other', 'Neighbour'].includes(value)
